import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { app } from '#utilities/js/ea/skins.js'
import { init } from '#utilities/js/ea/permissions.js'
import plugins from '../plugins/plugins.js'

const { root } = defaults
const skin = root.getAttribute('data-skin')
if (skin === app) {
  const { permissions } = plugins

  
  if (permissions) {
    const {
      READ_EXTERNAL_STORAGE,
      WRITE_EXTERNAL_STORAGE,
      MODIFY_AUDIO_SETTINGS,
      RECORD_AUDIO,
      CAMERA,
      WAKE_LOCK,
    } = permissions

    const pairs = Object.fromEntries(Object.keys({
      READ_EXTERNAL_STORAGE,
      WRITE_EXTERNAL_STORAGE,
      MODIFY_AUDIO_SETTINGS,
      RECORD_AUDIO,
      CAMERA,
      WAKE_LOCK,
    }).map(key => [key, key]))
    
    init(permissions, object(null, pairs))
  }
}
